<template>
  <div class="search">
    <button class="search-revoke hide" @click="cancelSearch" id="deny_reset_btn">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar">
      <label for="search-bar-input-sms-deny" class="blind">검색창</label>
      <input
        id="search-bar-input-sms-deny"
        type="text"
        autocomplete="off"
        maxlength="0"
        placeholder="상세 검색"
        v-on:focus="openDetailSearch"
      />

      <button class="search-button" type="button" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmsResultSearchBox',
  data() {
    return {
      isSearchComplete: false,
    };
  },
  methods: {
    openDetailSearch() {
      window.smsDeny.openSearchDetailLayer();
    },
    cancelSearch() {
      window.smsDeny.resetSearchDetail();
    },
  },
};
</script>
